export default __webpack_public_path__ + "static/media/flag-lt.b4d34851.svg";